import React from "react";

import "./SplashLoader.scss";
import AnimatedLoader from "../AnimatedLoader/AnimatedLoader";

function SplashLoader() {
  return (
    <div className="splash-loader-wrapper">
      <AnimatedLoader />
    </div>
  );
}

export default SplashLoader;
